import { Component } from "vue-property-decorator";
import BaseBlock from "@/blocks/base-block";
import { Block } from '../../../helpers/components';
import { UniversalFormMailRequestDTO } from '../../../model/UniversalFormMailRequestDTO';

import Bowser from 'bowser';

@Block() @Component
export class UniversalForm extends BaseBlock {
	//sending: boolean = false;
	//success: boolean = false;
	//failure: boolean = false;

	recaptchaResponse: string = null;
	gdprInformation: string = null;

	successElement: HTMLFormElement = null;
	sendingElement: HTMLFormElement = null;
	failureElement: HTMLFormElement = null;
	recaptchaFormUniversal: any;

	mounted() {
		this.successElement = document.getElementById(this.getText('form-success')) as HTMLFormElement;
		this.sendingElement = document.getElementById(this.getText('form-sending')) as HTMLFormElement;
		this.failureElement = document.getElementById(this.getText('form-failure')) as HTMLFormElement;

		this.successElement.setAttribute('hidden', '');
		this.sendingElement.setAttribute('hidden', '');
		this.failureElement.setAttribute('hidden', '');
	}

	

	async submit() {
		const form = this.$refs.form as HTMLFormElement;

		const formData = new FormData(form);

		console.log(Array.from(formData.entries()));

		const mailFormItems = this.getText('mail-form-items').split(';');

		const gdprFormItemName = this.getText('form-gdpr-item-name');
		const gdprFormItemValue = formData.get(gdprFormItemName);

		let messageFormData = mailFormItems.map(inputName => {
			const input = form[inputName] as HTMLElement;
			const label = input.getAttribute('data-mail-label') || inputName;

			if (label === gdprFormItemName && gdprFormItemValue === "on") {
				const bowser = Bowser.parse(window.navigator.userAgent)
				this.gdprInformation = "" + this.$store.timeId + "," + this.$store.langId + "," + bowser.browser.name.toString() + "," + bowser.browser.version.toString() + "," + bowser.os.name.toString() + "," + bowser.os.version.toString() + "";


				return '- Klient souhlasí se zpracováním osobních údajů'
			}

			return `- ${label}: ${formData.get(inputName)} <br>`;
		}).join('\n\r');

		const clientMailItemName = this.getText('form-client-mail-item');

		const mailRequest: UniversalFormMailRequestDTO = {
			mailTo: this.getText('mail-to'),
			mailToClient: clientMailItemName && formData.get(clientMailItemName) as string,
			message: this.getText('mail-template', [messageFormData]),
			messageToClient: this.getText('mail-client-template', [messageFormData]),
			/*recaptchaResponse: this.recaptchaResponse,*/
			recaptchaResponse: "",
			senderName: this.getText('sender-name'),
			senderEmail: this.getText('sender-email'),
			gdprInformation: this.gdprInformation,
			subject: this.getText('subject')
		};

		try {
			//this.sending = true;
			this.sendingElement.removeAttribute('hidden');

			await this.$mailService.sendUniversalFormMail(mailRequest);
			console.log(mailRequest);

			this.successElement.removeAttribute('hidden');
			this.sendingElement.setAttribute('hidden', '');
			this.failureElement.setAttribute('hidden', '');

			//reset form and recaptcha
			form.reset();
			(window as any).grecaptcha.reset(this.recaptchaFormUniversal);


			//this.sending = false;
			//this.success = true;
			//this.failure = false;
		} catch (e) {
			this.successElement.removeAttribute('hidden');
			this.sendingElement.removeAttribute('hidden');
			this.failureElement.setAttribute('hidden', '');

			//this.sending = false;
			//this.success = false;
			//this.failure = true;
		}
	}

	verifyCaptcha(response: string) {
		this.recaptchaResponse = response;
		console.log(this.recaptchaResponse);
	}

	renderCaptcha(el: HTMLElement) {
		const recaptchaElement = el.querySelector('.g-recaptcha') as HTMLElement;

		if (recaptchaElement) {
			this.recaptchaFormUniversal = (window as any).grecaptcha.render(recaptchaElement, {
				sitekey: "6LeThBsUAAAAAFERgnq9mO-hXXdAHWidfIXuu4Bo",
				callback: this.verifyCaptcha.bind(this)
			});

			recaptchaElement.style.position = 'relative';

			const recaptchaResponseElement = el.querySelector('.g-recaptcha-response') as HTMLTextAreaElement;
			recaptchaResponseElement.setAttribute('required', 'required');
			recaptchaResponseElement.style.position = 'absolute';
			recaptchaResponseElement.style.display = 'block';
			recaptchaResponseElement.style.top = '0';
			recaptchaResponseElement.style.zIndex = '-9999';
			recaptchaResponseElement.style.visibility = 'hidden';
		}
	}
}

export default UniversalForm;
